import { render, staticRenderFns } from "./EdCustomDestination.vue?vue&type=template&id=47d5f53c&"
import script from "./EdCustomDestination.vue?vue&type=script&lang=js&"
export * from "./EdCustomDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports